export class ResetPasswordController {
    /* @ngInject */
    constructor(passwordCredentialsService, authenticatedUserService, userSession, contactPointService, $stateParams, $state, authenticatedUser, uuid, deviceTokenService) {
        this.passwordCredentialsService = passwordCredentialsService;
        this.authenticatedUserService = authenticatedUserService;
        this.contactPointService = contactPointService;
        this.deviceTokenService = deviceTokenService;
        this.userSession = userSession;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.authenticatedUser = authenticatedUser;
        this.uuid = uuid;
    }

    $onInit() {
        this.id = this.$stateParams.id;
        this.username = this.$stateParams.username;
        this.changePassword = {};
        this.resetResponse = null;
        this.contactPoints = null;
        this.checkState(this.authenticatedUser);
        this.data = null;
        this.userDetails = null;
    }

    hasUsername() {
        return this.authenticatedUser || this.username;
    }

    checkState(authenticatedUser) {
        if ((authenticatedUser) && (!this.username)) {
            this.username = authenticatedUser.name;
        }
    }

    isActivating() {
        return this.authenticatedUser && !this.authenticatedUser.activated;
    }

    handleActivation() {
        if (this.authenticatedUser && !this.authenticatedUser.activated) {
            this.sendForActivation();
        } else {
            this.handleResetPassword();
        }
    }

    handleResetPassword() {
        this.authenticatedUserService.getAuthenticatedUserByUsername(this.username)
            .then(response => {
                if (response.data.locked){
                    this._handleError("IS_LOCKED");
                } else {
                    this.requestContactPoints(response);
                }
            })
            .catch(response => {
                this._handleError(response.data.loginStatus);
            });
    }

    requestContactPoints(response) {
        this.contactPointService.requestContactPoints(response.data.id)
            .then(response => {
                    this._handleSuccess(response);
                },
                response => {
                    this._handleError(response);
                });
    }

    sendForActivation() {
        if (!this.username) {
            this.username = this.authenticatedUser.name;
        }
        this.passwordCredentialsService.activateUser(this.username, this.changePassword.newPassword, this.uuid, this.$stateParams.email)
            .then(response => {
                this.authenticatedUser.activated = true;
                this._handleSuccess(response);
            }, response => {
                this._handleError(response);
            });
    }

    _handleSuccess(response) {
        this.contactPoints = response;
        if ((this.authenticatedUser) && (this.authenticatedUser.activated === true && response.loginStatus === "SUCCESS")) {
            this._createCookie();
            this.$state.go('activate.complete', {id: this.authenticatedUser.id});
        }
        else {
            this.$state.go('verifycode', {
                type: 'RESET_PASSWORD',
                username: this.username,
                password: this.changePassword.newPassword,
                contactPoints: this.contactPoints
            });
        }
    }

    _createCookie(){
        var userDetails = this.userSession[0];
        this.deviceTokenService.createCookie(userDetails, this.uuid);
    }

    _handleError(loginStatus) {
        if (loginStatus === 'INVALID_USERNAME') {
            this.errorResponse = loginStatus;
        } else if (loginStatus === 'IS_LOCKED') {
            this.errorResponse = loginStatus;
        } else {
            this.errorResponse = loginStatus;
            this.email = null;
        }
    }
}
